export const MODEL_DATA = 'MODEL_DATA'

export const setModelData = metaModels => {
    return dispatch => {
        dispatch({
            type: MODEL_DATA,
            metaModels,
        })
    }
}
